// Cook-mode text, made readable at a glance (Matt, 2026-10-02: "They're
// just like a block of text and sometimes it's more than I can sort of put
// in my head"). Nothing here rewrites the recipe: a step is split into its
// sentences so the first can be the headline and the rest sit underneath a
// line each, and the amounts, times and temperatures are picked out so the
// eye lands on the numbers. Same words, so the rule about what text may sit
// above a text box (CLAUDE.md, "The word pan") is untouched.

// A sentence ends at . ! or ? followed by a space and a capital, a digit or
// an opening quote. The lessons have no abbreviations that would trip it,
// and the test holds them to that.
export function sentences (text) {
  if (!text) return [];
  return String(text).trim().split(/(?<=[.!?])\s+(?=[A-Z0-9“"‘'½¼¾])/).map((s) => s.trim()).filter(Boolean);
}

// The first sentence, and everything after it.
export function headline (text) {
  const [first = '', ...rest] = sentences(text);
  return { first, rest };
}

// "into a cup" is a container, not an amount; "in a heaped teaspoon" and
// "in 3 tablespoons" are amounts.
const A_CONTAINER = String.raw`(?<=\b(?:into|in|from|on|onto|over) )\ban?\s(?:\w+\s)?cups?\b`;
const COUNT = String.raw`(?:(?<![\d.,/])\d+(?:[.,/]\d+)?(?:\s?[½¼¾])?|(?<!\d)[½¼¾]|\b(?:one|two|three|four|five|six|seven|eight|nine|ten|twelve|half an?)|(?!${A_CONTAINER})\ban?)`;
const RANGE = String.raw`(?:\s?(?:to|–|-)\s?\d+(?:[.,/]\d+)?)?`;
const SIZE = String.raw`(?:\s(?:heaped|heaping|level|big|good|generous|scant))?`;
const UNIT = String.raw`(?:tablespoons?|teaspoons?|tbsp|tsp|cups?|pinch(?:es)?|splash(?:es)?|handfuls?|cloves?|pounds?|lbs?|ounces?|oz|quarts?|inch(?:es)?|minutes?|mins?|seconds?|secs?|hours?|hrs?)`;
const AMOUNT = new RegExp(String.raw`\d+\s?°[FC]|${COUNT}${RANGE}${SIZE}\s${UNIT}\b`, 'gi');

// Text as pieces, the amounts marked { strong: true }. Pieces rather than
// HTML so the template never needs v-html.
export function emphasize (text) {
  const out = [];
  const s = String(text || '');
  let last = 0;
  for (const m of s.matchAll(AMOUNT)) {
    if (m.index > last) out.push({ text: s.slice(last, m.index), strong: false });
    out.push({ text: m[0], strong: true });
    last = m.index + m[0].length;
  }
  if (last < s.length) out.push({ text: s.slice(last), strong: false });
  return out;
}
